// extracted by mini-css-extract-plugin
export default {"actionError":"ConstructElements_actionError__9sQxP","blockTitle":"ConstructElements_blockTitle__3l1Sb","separator":"ConstructElements_separator__wbqyo"};